export default __webpack_public_path__ + "static/skills-tag-parts-dark-a4610b83debd0e7a805846a9a63902cff80c6c4a5808b3a909418224c09dbe95.png";